import * as React from 'react';
import * as _ from 'underscore';
import { ResetPasswordActionPage } from '~src/authentication/components/ResetPasswordActionPage';

import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export interface ResetPasswordProviderProps {
  readonly token: string;
  readonly username: string;
}

export const ResetPasswordProvider = (props: ResetPasswordProviderProps): JSX.Element => {
  const token = _.isUndefined(props.token) ? '' : props.token;
  return(
    <DefaultServerTitleWrapper>
      <div>
        <ResetPasswordActionPage {...props}/>
      </div>
    </DefaultServerTitleWrapper>
  );
};
